import Button from '@breeze-platform-ui/button';
import { Int16Close } from '@breeze-platform-ui/iconsPack';

import starsImg from './stars.svg';

type Props = {
  title: string;
  subtitle: string;
  onCancel: () => void;
};
export const OfferBanner = ({ title, subtitle, onCancel }: Props) => {
  return (
    <div className="flex w-full items-center justify-between gap-4 pb-5">
      <div className="box-border flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[linear-gradient(180deg,#4d77ff_0%,#729bff_30.73%,#72aff8_58.33%,#72e7f6_100%)]">
        <img src={starsImg} alt="" height="24" width="24" />
      </div>
      <div className="grow">
        <div className="text-m font-bold" data-qa-type="special-offer-title">
          {title}
        </div>
        <div
          className="text-s text-text-primary"
          data-qa-type="special-offer-subtitle"
        >
          {subtitle}
        </div>
      </div>
      <Button
        dataQaType="cancel-offer-button"
        theme="secondary"
        size="s"
        onClick={onCancel}
        icon={<Int16Close theme={{ color: '#5BA6FD' }} />}
      />
    </div>
  );
};
